import React from "react";
import { LeagueWithCurrentUserAssignment } from "../../store/leagues/models";
import { Data, isLoaded } from "../../framework/data";
import MatchesTable from "./MatchesTable";
import { MatchHeader, Set } from "../../store/matches/models";
import { withRouter, match } from "react-router-dom";
import { connect } from "react-redux";
import { AppState } from "../../store/reducer";
import { usersAssignedLeague } from "../../store/leagues/selectors";
import { Dispatch } from "redux";
import { loadLeagueDetails } from "../../store/leagues/actions";
import { getLeaguesMatches, adminSubmitMatchResult, adminUpdateMatchResult } from "../../store/matches/actions";
import { Button, Tooltip, IconButton } from "@material-ui/core";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import PostAddIcon from '@material-ui/icons/PostAdd';
import EditDocumentIcon from '@material-ui/icons/EditOutlined';
import MatchResultDialog from "./MatchResultDialog";
import { Player } from "../../store/players/models";
import { useAuth0 } from "@auth0/auth0-react";
import { getConfig } from "../../config/configuration";

interface AllMatchesAdminPageProps {
  league: Data<LeagueWithCurrentUserAssignment>;
  matches: Data<MatchHeader[]>;
  match: match<{ year: string; id: string }>;
  loadLeagueDetails: (year: string, id: string) => void;
  loadLeagueMatches: (
    year: string,
    id: string,
    skip: number,
    take: number,
    order: string
  ) => void;
  submitResult: (
    match: MatchHeader,
    league: LeagueWithCurrentUserAssignment,
    sets: Set[],
    skip: number,
    take: number,
    token: string
  ) => void;
  updateResult: (
    match: MatchHeader,
    league: LeagueWithCurrentUserAssignment,
    sets: Set[],
    skip: number,
    take: number,
    token: string
  ) => void;
}

const AllMatchesAdminPage: React.FC<AllMatchesAdminPageProps> = ({
  league,
  loadLeagueDetails,
  loadLeagueMatches,
  matches,
  match,
  submitResult,
  updateResult
}) => {
  const [page, setPage] = React.useState<number>();
  const [pageSize, setPageSize] = React.useState<number>();
  const [matchResultDialogOpen, setMatchResultDialogOpen] = React.useState<
    boolean
  >(false);
  const [currentMatch, setCurrentMatch] = React.useState<MatchHeader>();
  const { getAccessTokenSilently } = useAuth0();

  const [tenant, setTenant] = React.useState<string>("");

  React.useEffect(() => {
    getConfig().then((c) => {
      setTenant(c.key as string);
    });
  }, [])

  React.useEffect(() => {
    var id = match.params.id;
    var year = match.params.year;

    if (!isLoaded(league)) {
      loadLeagueDetails(year, id);
    }

    if (league.type === "LOADED" && tenant) {
      loadLeagueMatches(league.value.year, league.value.id, 0, 25, (tenant === "gorzow" ? "asc" : "desc"));
    };

  }, [
    match.params.id,
    match.params.year,
    loadLeagueDetails,
    league,
    loadLeagueMatches,
    tenant
  ]);

  const handleMatchResult = async (success: boolean, sets: Set[]) => {
    if (success && league.type === "LOADED" && currentMatch) {
      const token = await getAccessTokenSilently();

      if (!!currentMatch.score) {
        updateResult(
          currentMatch,
          league.value,
          sets,
          (page || 0) * (pageSize || 25),
          pageSize || 25,
          token
        )
      } else {
        submitResult(
          currentMatch,
          league.value,
          sets,
          (page || 0) * (pageSize || 25),
          pageSize || 25,
          token
        );
      }


    }
    setMatchResultDialogOpen(false);
  };

  return (
    <>
      {league.type === "LOADED" && matches.type === "LOADED" ? (<>
        <MatchResultDialog
          open={matchResultDialogOpen}
          intialSets={currentMatch?.score}
          firstPlayer={currentMatch?.firstPlayer}
          secondPlayer={currentMatch?.secondPlayer}
          onClosed={(success, sets, walkover) => handleMatchResult(success, sets)}
          currentPlayer={{} as Player}
          onHelpRequested={() => /*handleHelpRequested()*/ { }}
        ></MatchResultDialog>
        <MatchesTable
          forSinglePlayerOnly={false}
          matches={matches.value}
          onLoadData={async (page, pageSize) => {
            const skip = page * pageSize;
            const take = pageSize;
            loadLeagueMatches(
              league.value.year,
              league.value.id,
              skip,
              take,
             "asc"
            );
            setPage(page);
            setPageSize(pageSize);
          }}
          page={page || 0}
          pageSize={pageSize || 25}
          actions={m => {
            const submitAction = (<Tooltip title="Podaj wynik meczu" key="3">
              <IconButton
                size="small"
                onClick={() => {
                  setCurrentMatch(m);
                  setMatchResultDialogOpen(true);
                }}
              >
                <PostAddIcon></PostAddIcon>
              </IconButton>
            </Tooltip>);

            const editAction = (<Tooltip title="Edytuj wynik meczu" key="3">
              <IconButton
                size="small"
                onClick={() => {
                  setCurrentMatch(m);
                  setMatchResultDialogOpen(true);
                }}
              >
                <EditDocumentIcon></EditDocumentIcon>
              </IconButton>
            </Tooltip>);

            const actions: JSX.Element[] = [!!m.score ? editAction : submitAction];

            return <>{actions}</>;
          }}
        ></MatchesTable>
      </>) : (
          <></>
        )}
      <Button startIcon={<ChevronLeftIcon />} onClick={() => window.history.back()}>Powrót</Button>
    </>
  );
}

const mapStateToProps = (state: AppState) => {
  return {
    league: usersAssignedLeague(state),
    matches: state.matches.currentLeagueAllMatchesPage
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    loadLeagueDetails: (year: string, id: string) => dispatch(loadLeagueDetails({ year, id })),
    loadLeagueMatches: (
      year: string,
      id: string,
      skip: number,
      take: number,
      order: string
    ) => dispatch(getLeaguesMatches({ year, id, skip, take, order })),
    submitResult: (
      match: MatchHeader,
      league: LeagueWithCurrentUserAssignment,
      sets: Set[],
      skip: number,
      take: number,
      token: string
    ) =>
      dispatch(
        adminSubmitMatchResult({
          leagueId: league.id,
          matchId: match.id,
          sets,
          skip,
          walkover: false,
          take,
          token,
          year: league.year,
          order: "asc"
        })
      ),
    updateResult: (
      match: MatchHeader,
      league: LeagueWithCurrentUserAssignment,
      sets: Set[],
      skip: number,
      take: number,
      token: string
    ) => dispatch(adminUpdateMatchResult({
      leagueId: league.id,
      matchId: match.id,
      sets,
      skip,
      walkover: false,
      take,
      token,
      year: league.year, 
      order: "asc"
    })

    )
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AllMatchesAdminPage)
);